module.exports = __webpack_public_path__ + "img/blue_091.11c18baa.png";